class AppPager extends Component {
	constructor(el) {
		super(el);
		this.loadBtn = this.$find('[data-load-more]');
		this.staticPager = this.$find('[data-pager-static]');
		this.resultContainer = document.querySelector('[data-ajax-results]');
		this.addEventListeners();
	}

	loadItems() {
		fetch(this.$el.dataset.nextUrl+'&ajax=yes')
			.then(response => response.json())
			.then(data => {
				if (data.status === 'OK') this.onSuccess(data);
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}

	appendItems(items) {
		if(this.resultContainer) {
			const rect = this.resultContainer.getBoundingClientRect();
			const topPosition = (rect.top + window.scrollY) + rect.height;
			this.resultContainer.innerHTML += items;
			window.scrollTo(0, topPosition);
			Component.initComponents();

		}
	}

	refreshStaticPager(pagerHTML) {
		const newPager = document.createElement('div');
		newPager.innerHTML = pagerHTML.trim();
		const newPagerStatic = newPager.querySelector('[data-pager-static]');

		this.staticPager.replaceWith(newPagerStatic);
		this.staticPager = newPagerStatic;
	}

	onSuccess(data) {
		history.pushState(null, null, this.$el.dataset.nextUrl);

		this.appendItems(data.itemsHTML);
		this.refreshStaticPager(data.paginationHTML);

		if (data.nextPage) {
			this.$el.dataset.nextUrl = data.nextPage;
		} else {
			this.$el.dataset.nextUrl = '';
			this.loadBtn.remove();
		}
	}

	addEventListeners() {
		this.loadBtn && this.loadBtn.addEventListener('click', () => this.loadItems());
	}
}
